import PropTypes from 'prop-types';

const seasonShape = PropTypes.shape({
  label: PropTypes.string,
  seasonId: PropTypes.string,
  year: PropTypes.number,
});

export default seasonShape;
